import { practiceStore } from '../stores/practiceStore';
import { getPractices } from '../queries';
import { useMutation } from '@tanstack/react-query';

export function useGetPractices() {
  const { setPractice } = practiceStore()
  const { mutate, data, isError, isPending } = useMutation({
    mutationKey: ['practiceList'], 
    mutationFn: () => getPractices(),
    onSuccess: (response) => {
      setPractice(response);
    },
    retry: false
  });
  
  return { data, isError, isLoading: isPending, mutate }
}
